<template>
  <div class="columns">
    <div class="column is-12-mobile is-12-desktop is-12-widescreen">
      <div class="level">
        <div class="column is-three-fifths-desktop">
          <div class="card custom-panel main-card">
            <div class="card-content">
              <article class="media">
                <div class="media-content">
                  <!--<div class="content"></div>-->
                  <p v-if="this.notes.length===0">There are no notes for this business.</p>
                  <div v-for="(note, index) in notes" class="margin-bottom-20">
                    <div class="margin-bottom-5">
                      <strong>{{ note.author }}</strong>
                      on {{ note.datetime | prettyDateTime }}
                    </div>
                    <p v-html="note.content"></p>
                  </div>
                </div>
              </article>
              <!-- Messages -->

            </div>
          </div>
          <div class="field">
            <div class="control" :class="{'is-loading': creatingNote}">
              <textarea value="newNote" :disabled="creatingNote" v-model="newNote" :name="newNote" class="textarea notesField" :shouldClear="clearReplyBox"></textarea>
            </div>
          </div>
          <div class="columns is-multiline">
            <div class="column is-4-mobile is-6-desktop is-6-widescreen buttons is-pulled-right noteButtonCss">
              <button :disabled="newNote === ''" @click.prevent="addBusinessNote" :class="[{ 'is-loading': creatingNote }, 'button is-button-blue is-fullwidth is-pulled-right']">
                ADD NOTE
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
    import axios from 'axios'
    import misc from '../../mixins/misc'

    export default {
        mixins: [misc],
        data () {
            return {
                newNote: '',
                creatingNote: false,
                notes: [],
                clearReplyBox: false,
                showNotes: true
            }
        },
        computed: {
            getBusinessSlug () {
                return this.$router.currentRoute.params.slug
            }
        },
        created () {
            this.getBusinessNotes()
        },
        methods: {
            /**
             * Makes an api call to get all business note related to business slug
             * @return {void}
             */
            getBusinessNotes () {
                axios.get(`business/${this.getBusinessSlug}/get-business-notes`)
                    .then(({data}) => {
                        for (let noteData of data) {
                            this.notes.push({author: noteData.author.full_name, datetime: noteData.created_datetime, content: noteData.content})
                        }
                    })
                    .catch(() => {
                        const errMessage = 'We encountered a problem in an attempt to retrieve business notes for this business, please try again later.'
                        flash(errMessage, 'is-danger')
                        dataLayer.push({
                            'userMessage': {
                                'messageType': 'error',
                                'messageName': 'Failed to get business notes on Business Profile view',
                                'displayedMessage': errMessage
                            }
                        })
                    })
            },
            /**
             * Add new business note
             * @return {void}
             */
            addBusinessNote () {
                this.creatingNote = true
                axios.post(`business/${this.getBusinessSlug}/add-business-notes`, {
                    content: this.newNote
                }).then(({data}) => {
                    this.creatingNote = false
                    this.notes.push({author: data.author, datetime: data.datetime, content: this.newNote})
                    this.newNote = ''
                    this.clearReplyBox = !this.clearReplyBox
                    if (data.status === 'success') {
                        flash(`Business note has been successfully added.`)
                        dataLayer.push({
                            'userMessage': {
                                'messageType': 'success',
                                'messageName': 'Successfully added business not on Business Note view',
                                'displayedMessage': 'Business note added successfully.'
                            }
                        })
                    }
                })
                    .catch((error) => {
                        this.creatingNote = false
                        if (error.response && error.response.status === 400) {
                            flash(error.response.data.message, 'is-danger')
                            dataLayer.push({
                                'userMessage': {
                                    'messageType': 'error',
                                    'messageName': 'Failed to add business notes on Business Note view',
                                    'displayedMessage': error.response.data.message
                                }
                            })
                        }
                    })
            }
        }
    }
</script>

<style scoped>
  .noteButtonCss {
    padding-right: 0px;
    width: 100%;
  }
  .noteButtonCss button {
    width: 100px !important;
  }

</style>



// WEBPACK FOOTER //
// src/pages/admin/BusinessNotes.vue